import axiosInstance from "../axiosInterceptor";

export async function getCategoryWiseSubcategory(categoryId) {
  const response = await axiosInstance.get(
    `/admin/subcategory/getCategoryWiseSubcategory/${categoryId}`
  );
  const data = response?.data;
  return data;
}
